import FrequentlyAskedQuestion from './FrequentlyAskedQuestion';

const keyWords = {
  registerToPlaceOrder: [
    {
      "value": "need",
      "weight": 1
    },
    {
      "value": "register",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 4
    },
    {
      "value": "place",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "necessary",
      "weight": 1
    },
    {
      "value": "created",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "enables",
      "weight": 1
    },
    {
      "value": "provide",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 2
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "best",
      "weight": 1
    },
    {
      "value": "possible",
      "weight": 1
    },
    {
      "value": "service",
      "weight": 1
    },
    {
      "value": "managing",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "leverage",
      "weight": 1
    },
    {
      "value": "benefits",
      "weight": 2
    },
    {
      "value": "manager",
      "weight": 1
    },
    {
      "value": "other",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 1
    },
    {
      "value": "might",
      "weight": 1
    },
    {
      "value": "able",
      "weight": 1
    },
    {
      "value": "offer",
      "weight": 1
    }
  ],
  registerForOnAccount: [
    {
      "value": "need",
      "weight": 2
    },
    {
      "value": "provide",
      "weight": 2
    },
    {
      "value": "register",
      "weight": 2
    },
    {
      "value": "account",
      "weight": 3
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "only",
      "weight": 1
    },
    {
      "value": "valid",
      "weight": 1
    },
    {
      "value": "email",
      "weight": 1
    },
    {
      "value": "address",
      "weight": 2
    },
    {
      "value": "name",
      "weight": 1
    },
    {
      "value": "phone",
      "weight": 1
    },
    {
      "value": "number",
      "weight": 1
    },
    {
      "value": "password",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "also",
      "weight": 1
    },
    {
      "value": "required",
      "weight": 1
    },
    {
      "value": "when",
      "weight": 1
    },
    {
      "value": "finalising",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "creation",
      "weight": 1
    }
  ],
  registerOnBehalfOfSomeoneElse: [
    {
      "value": "register",
      "weight": 1
    },
    {
      "value": "someone",
      "weight": 1
    },
    {
      "value": "elses",
      "weight": 1
    },
    {
      "value": "behalf",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "must",
      "weight": 2
    },
    {
      "value": "their",
      "weight": 2
    },
    {
      "value": "permission",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 3
    },
    {
      "value": "registered",
      "weight": 1
    },
    {
      "value": "against",
      "weight": 1
    },
    {
      "value": "email",
      "weight": 2
    },
    {
      "value": "address",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "imperative",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "used",
      "weight": 1
    },
    {
      "value": "finalise",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "creation",
      "weight": 1
    },
    {
      "value": "addition",
      "weight": 1
    },
    {
      "value": "being",
      "weight": 1
    },
    {
      "value": "sent",
      "weight": 1
    },
    {
      "value": "notifications",
      "weight": 1
    },
    {
      "value": "throughout",
      "weight": 1
    },
    {
      "value": "lifetime",
      "weight": 1
    }
  ],
  registerMoreThanOneUser: [
    {
      "value": "register",
      "weight": 2
    },
    {
      "value": "more",
      "weight": 1
    },
    {
      "value": "than",
      "weight": 1
    },
    {
      "value": "one",
      "weight": 1
    },
    {
      "value": "person",
      "weight": 1
    },
    {
      "value": "under",
      "weight": 2
    },
    {
      "value": "account",
      "weight": 2
    },
    {
      "value": "individuals",
      "weight": 1
    },
    {
      "value": "cannot",
      "weight": 1
    },
    {
      "value": "shared",
      "weight": 1
    },
    {
      "value": "multiple",
      "weight": 2
    },
    {
      "value": "users",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "individual",
      "weight": 2
    },
    {
      "value": "accounts",
      "weight": 2
    },
    {
      "value": "managed",
      "weight": 1
    },
    {
      "value": "company",
      "weight": 2
    },
    {
      "value": "record",
      "weight": 1
    },
    {
      "value": "therefore",
      "weight": 1
    },
    {
      "value": "possible",
      "weight": 1
    },
    {
      "value": "yourself",
      "weight": 1
    },
    {
      "value": "colleagues",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "same",
      "weight": 1
    }
  ],
  registerHowLongToEnableInvoicing: [
    {
      "value": "long",
      "weight": 1
    },
    {
      "value": "does",
      "weight": 1
    },
    {
      "value": "take",
      "weight": 2
    },
    {
      "value": "enable",
      "weight": 1
    },
    {
      "value": "monthly",
      "weight": 1
    },
    {
      "value": "invoicing",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 2
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 2
    },
    {
      "value": "active",
      "weight": 1
    },
    {
      "value": "once",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 3
    },
    {
      "value": "create",
      "weight": 1
    },
    {
      "value": "password",
      "weight": 1
    },
    {
      "value": "part",
      "weight": 1
    },
    {
      "value": "registration",
      "weight": 1
    },
    {
      "value": "process",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "would",
      "weight": 1
    },
    {
      "value": "like",
      "weight": 1
    },
    {
      "value": "invoiced",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 2
    },
    {
      "value": "up",
      "weight": 1
    },
    {
      "value": "3",
      "weight": 1
    },
    {
      "value": "working",
      "weight": 1
    },
    {
      "value": "days",
      "weight": 1
    },
    {
      "value": "activated",
      "weight": 1
    },
    {
      "value": "interim",
      "weight": 1
    },
    {
      "value": "still",
      "weight": 1
    },
    {
      "value": "able",
      "weight": 1
    },
    {
      "value": "place",
      "weight": 1
    },
    {
      "value": "paying",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "paypal",
      "weight": 1
    }
  ],
  registerContactDetails: [
    {
      "value": "who",
      "weight": 1
    },
    {
      "value": "contact",
      "weight": 1
    },
    {
      "value": "registration",
      "weight": 1
    },
    {
      "value": "details",
      "weight": 1
    },
    {
      "value": "arent",
      "weight": 1
    },
    {
      "value": "accepted",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 2
    },
    {
      "value": "encounter",
      "weight": 1
    },
    {
      "value": "issue",
      "weight": 1
    },
    {
      "value": "when",
      "weight": 1
    },
    {
      "value": "trying",
      "weight": 1
    },
    {
      "value": "register",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "either",
      "weight": 1
    },
    {
      "value": "call",
      "weight": 1
    },
    {
      "value": "use",
      "weight": 1
    },
    {
      "value": "enquiry",
      "weight": 1
    },
    {
      "value": "form",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    },
    {
      "value": "member",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "team",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "get",
      "weight": 1
    },
    {
      "value": "back",
      "weight": 1
    }
  ],
  orderingPlaceOrderOnWebsite: [
    {
      "value": "place",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 2
    },
    {
      "value": "website",
      "weight": 2
    },
    {
      "value": "ordering",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "preferred",
      "weight": 1
    },
    {
      "value": "method",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 1
    },
    {
      "value": "accommodate",
      "weight": 1
    },
    {
      "value": "placing",
      "weight": 1
    },
    {
      "value": "email",
      "weight": 1
    },
    {
      "value": "although",
      "weight": 1
    },
    {
      "value": "all",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 2
    },
    {
      "value": "created",
      "weight": 1
    },
    {
      "value": "against",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 3
    },
    {
      "value": "online",
      "weight": 2
    },
    {
      "value": "account",
      "weight": 2
    },
    {
      "value": "deliverables",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "through",
      "weight": 1
    }
  ],
  orderingWhatInformationDoIProvide: [
    {
      "value": "information",
      "weight": 1
    },
    {
      "value": "need",
      "weight": 2
    },
    {
      "value": "provide",
      "weight": 3
    },
    {
      "value": "order",
      "weight": 2
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "utility",
      "weight": 2
    },
    {
      "value": "search",
      "weight": 2
    },
    {
      "value": "report",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 2
    },
    {
      "value": "simply",
      "weight": 1
    },
    {
      "value": "draw",
      "weight": 1
    },
    {
      "value": "site",
      "weight": 2
    },
    {
      "value": "boundary",
      "weight": 1
    },
    {
      "value": "reference",
      "weight": 1
    },
    {
      "value": "select",
      "weight": 1
    },
    {
      "value": "description",
      "weight": 1
    },
    {
      "value": "works",
      "weight": 1
    },
    {
      "value": "request",
      "weight": 2
    },
    {
      "value": "turnaround",
      "weight": 1
    },
    {
      "value": "time",
      "weight": 1
    },
    {
      "value": "optionally",
      "weight": 1
    },
    {
      "value": "also",
      "weight": 1
    },
    {
      "value": "onbehalf",
      "weight": 1
    },
    {
      "value": "proof",
      "weight": 1
    },
    {
      "value": "letter",
      "weight": 1
    },
    {
      "value": "inclusion",
      "weight": 1
    },
    {
      "value": "map",
      "weight": 1
    }
  ],
  orderingPayForOrder:[
    {
      "value": "pay",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 2
    },
    {
      "value": "support",
      "weight": 2
    },
    {
      "value": "number",
      "weight": 1
    },
    {
      "value": "payment",
      "weight": 2
    },
    {
      "value": "methods",
      "weight": 1
    },
    {
      "value": "most",
      "weight": 1
    },
    {
      "value": "users",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "prefer",
      "weight": 1
    },
    {
      "value": "invoiced",
      "weight": 1
    },
    {
      "value": "monthly",
      "weight": 1
    },
    {
      "value": "basis",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "also",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "credit",
      "weight": 1
    },
    {
      "value": "card",
      "weight": 2
    },
    {
      "value": "debit",
      "weight": 1
    },
    {
      "value": "paypal",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    }
  ],
  orderingCanIOrderMultipleSites: [
    {
      "value": "order",
      "weight": 2
    },
    {
      "value": "multiple",
      "weight": 1
    },
    {
      "value": "sites",
      "weight": 1
    },
    {
      "value": "single",
      "weight": 1
    },
    {
      "value": "unfortunately",
      "weight": 1
    },
    {
      "value": "not",
      "weight": 1
    },
    {
      "value": "at",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "time",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 1
    },
    {
      "value": "happy",
      "weight": 1
    },
    {
      "value": "discuss",
      "weight": 1
    },
    {
      "value": "facilitating",
      "weight": 1
    },
    {
      "value": "these",
      "weight": 1
    },
    {
      "value": "large",
      "weight": 1
    },
    {
      "value": "bulk",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "contact",
      "weight": 1
    },
    {
      "value": "one",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "managers",
      "weight": 1
    },
    {
      "value": "help",
      "weight": 1
    }
  ],
  orderingContactTheTeam: [
    {
      "value": "contact",
      "weight": 2
    },
    {
      "value": "someone",
      "weight": 1
    },
    {
      "value": "discuss",
      "weight": 1
    },
    {
      "value": "matter",
      "weight": 1
    },
    {
      "value": "relating",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "either",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "enquiry",
      "weight": 1
    },
    {
      "value": "forms",
      "weight": 1
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    },
    {
      "value": "through",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "phone",
      "weight": 1
    },
    {
      "value": "number",
      "weight": 1
    }
  ],
  orderingEstimate: [
    {
      "value": "get",
      "weight": 1
    },
    {
      "value": "estimate",
      "weight": 2
    },
    {
      "value": "cost",
      "weight": 1
    },
    {
      "value": "before",
      "weight": 1
    },
    {
      "value": "submit",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 4
    },
    {
      "value": "dynamic",
      "weight": 1
    },
    {
      "value": "pricing",
      "weight": 1
    },
    {
      "value": "engine",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "generate",
      "weight": 1
    },
    {
      "value": "any",
      "weight": 2
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "up",
      "weight": 3
    },
    {
      "value": "1",
      "weight": 2
    },
    {
      "value": "unit",
      "weight": 2
    },
    {
      "value": "size",
      "weight": 3
    },
    {
      "value": "ie",
      "weight": 1
    },
    {
      "value": "1km2",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 2
    },
    {
      "value": "unable",
      "weight": 1
    },
    {
      "value": "provide",
      "weight": 2
    },
    {
      "value": "estimates",
      "weight": 2
    },
    {
      "value": "utility",
      "weight": 3
    },
    {
      "value": "search",
      "weight": 3
    },
    {
      "value": "map",
      "weight": 2
    },
    {
      "value": "paypal",
      "weight": 1
    },
    {
      "value": "accounts",
      "weight": 2
    },
    {
      "value": "enabled",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "monthly",
      "weight": 2
    },
    {
      "value": "invoicing",
      "weight": 2
    },
    {
      "value": "report",
      "weight": 1
    },
    {
      "value": "32",
      "weight": 1
    },
    {
      "value": "units",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "request",
      "weight": 1
    },
    {
      "value": "enable",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 2
    },
    {
      "value": "at",
      "weight": 2
    },
    {
      "value": "time",
      "weight": 1
    },
    {
      "value": "when",
      "weight": 1
    },
    {
      "value": "ordering",
      "weight": 1
    },
    {
      "value": "checkout",
      "weight": 1
    },
    {
      "value": "stage",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    }
  ],
  orderingProvideSiteBoundary: [
    {
      "value": "provide",
      "weight": 1
    },
    {
      "value": "site",
      "weight": 4
    },
    {
      "value": "boundary",
      "weight": 3
    },
    {
      "value": "want",
      "weight": 1
    },
    {
      "value": "searched",
      "weight": 1
    },
    {
      "value": "draw",
      "weight": 2
    },
    {
      "value": "using",
      "weight": 1
    },
    {
      "value": "polygon",
      "weight": 2
    },
    {
      "value": "line",
      "weight": 2
    },
    {
      "value": "tools",
      "weight": 1
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "stage",
      "weight": 1
    },
    {
      "value": "ordering",
      "weight": 1
    },
    {
      "value": "process",
      "weight": 1
    },
    {
      "value": "note",
      "weight": 1
    },
    {
      "value": "only",
      "weight": 1
    },
    {
      "value": "single",
      "weight": 1
    },
    {
      "value": "permitted",
      "weight": 1
    },
    {
      "value": "tool",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "allow",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "easily",
      "weight": 1
    },
    {
      "value": "trace",
      "weight": 1
    },
    {
      "value": "linear",
      "weight": 1
    },
    {
      "value": "assets",
      "weight": 1
    },
    {
      "value": "such",
      "weight": 1
    },
    {
      "value": "those",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "might",
      "weight": 1
    },
    {
      "value": "follow",
      "weight": 1
    },
    {
      "value": "road",
      "weight": 1
    },
    {
      "value": "railway",
      "weight": 1
    },
    {
      "value": "route",
      "weight": 1
    }
  ],
  orderingSubmitLargeNumber: [
    {
      "value": "submit",
      "weight": 1
    },
    {
      "value": "large",
      "weight": 1
    },
    {
      "value": "number",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 2
    },
    {
      "value": "at",
      "weight": 1
    },
    {
      "value": "present",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 2
    },
    {
      "value": "would",
      "weight": 1
    },
    {
      "value": "advise",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "contact",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "enquiry",
      "weight": 1
    },
    {
      "value": "form",
      "weight": 1
    },
    {
      "value": "bulk",
      "weight": 1
    },
    {
      "value": "upload",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "into",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "fulfilment",
      "weight": 1
    },
    {
      "value": "system",
      "weight": 1
    }
  ],
  orderingSiteSizeLimit: [
    {
      "value": "there",
      "weight": 1
    },
    {
      "value": "limit",
      "weight": 1
    },
    {
      "value": "size",
      "weight": 4
    },
    {
      "value": "site",
      "weight": 2
    },
    {
      "value": "request",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 3
    },
    {
      "value": "although",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "depends",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 3
    },
    {
      "value": "status",
      "weight": 1
    },
    {
      "value": "paypal",
      "weight": 1
    },
    {
      "value": "only",
      "weight": 1
    },
    {
      "value": "less",
      "weight": 1
    },
    {
      "value": "than",
      "weight": 1
    },
    {
      "value": "1",
      "weight": 2
    },
    {
      "value": "unit",
      "weight": 2
    },
    {
      "value": "ie",
      "weight": 1
    },
    {
      "value": "1km2",
      "weight": 1
    },
    {
      "value": "currently",
      "weight": 1
    },
    {
      "value": "limited",
      "weight": 1
    },
    {
      "value": "utility",
      "weight": 3
    },
    {
      "value": "search",
      "weight": 3
    },
    {
      "value": "report",
      "weight": 2
    },
    {
      "value": "enabled",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "monthly",
      "weight": 1
    },
    {
      "value": "invoicing",
      "weight": 1
    },
    {
      "value": "up",
      "weight": 2
    },
    {
      "value": "32",
      "weight": 1
    },
    {
      "value": "units",
      "weight": 1
    },
    {
      "value": "map",
      "weight": 1
    }
  ],
  orderingReceivingMyOrder: [
    {
      "value": "receive",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 5
    },
    {
      "value": "your",
      "weight": 3
    },
    {
      "value": "found",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 2
    },
    {
      "value": "when",
      "weight": 2
    },
    {
      "value": "you",
      "weight": 2
    },
    {
      "value": "signed",
      "weight": 1
    },
    {
      "value": "into",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "any",
      "weight": 2
    },
    {
      "value": "deliverable",
      "weight": 1
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 2
    },
    {
      "value": "accessed",
      "weight": 1
    },
    {
      "value": "downloaded",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "deliverables",
      "weight": 1
    },
    {
      "value": "table",
      "weight": 1
    },
    {
      "value": "respective",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "also",
      "weight": 1
    },
    {
      "value": "recieve",
      "weight": 1
    },
    {
      "value": "email",
      "weight": 1
    },
    {
      "value": "notification",
      "weight": 1
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "download",
      "weight": 1
    },
    {
      "value": "along",
      "weight": 1
    },
    {
      "value": "revisions",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    }
  ],
  myOrdersAmendOrder: [
    {
      "value": "amend",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 2
    },
    {
      "value": "once",
      "weight": 1
    },
    {
      "value": "has",
      "weight": 1
    },
    {
      "value": "been",
      "weight": 1
    },
    {
      "value": "placed",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 2
    },
    {
      "value": "subject",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "status",
      "weight": 1
    },
    {
      "value": "type",
      "weight": 2
    },
    {
      "value": "amendment",
      "weight": 1
    },
    {
      "value": "requested",
      "weight": 2
    },
    {
      "value": "website",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "allow",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "add",
      "weight": 1
    },
    {
      "value": "utility",
      "weight": 1
    },
    {
      "value": "search",
      "weight": 1
    },
    {
      "value": "map",
      "weight": 1
    },
    {
      "value": "active",
      "weight": 1
    },
    {
      "value": "none",
      "weight": 1
    },
    {
      "value": "expired",
      "weight": 1
    },
    {
      "value": "dependent",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 2
    },
    {
      "value": "payment",
      "weight": 1
    },
    {
      "value": "other",
      "weight": 1
    },
    {
      "value": "amendments",
      "weight": 1
    },
    {
      "value": "must",
      "weight": 1
    },
    {
      "value": "performed",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 2
    },
    {
      "value": "operations",
      "weight": 1
    },
    {
      "value": "team",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "enquiry",
      "weight": 1
    },
    {
      "value": "form",
      "weight": 1
    },
    {
      "value": "speaking",
      "weight": 1
    },
    {
      "value": "manager",
      "weight": 1
    }
  ],
  myOrdersCancelling: [
    {
      "value": "cancel",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "might",
      "weight": 1
    },
    {
      "value": "subject",
      "weight": 1
    },
    {
      "value": "charge",
      "weight": 1
    },
    {
      "value": "calculated",
      "weight": 1
    },
    {
      "value": "based",
      "weight": 1
    },
    {
      "value": "percentage",
      "weight": 1
    },
    {
      "value": "work",
      "weight": 1
    },
    {
      "value": "undertaken",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "operations",
      "weight": 1
    },
    {
      "value": "team",
      "weight": 1
    },
    {
      "value": "any",
      "weight": 1
    },
    {
      "value": "disbursements",
      "weight": 1
    },
    {
      "value": "incurred",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "3rd",
      "weight": 1
    },
    {
      "value": "party",
      "weight": 1
    },
    {
      "value": "costs",
      "weight": 1
    }
  ],
  myOrdersDeliverables: [
    {
      "value": "retrieve",
      "weight": 1
    },
    {
      "value": "deliverables",
      "weight": 4
    },
    {
      "value": "associated",
      "weight": 2
    },
    {
      "value": "with",
      "weight": 2
    },
    {
      "value": "order",
      "weight": 3
    },
    {
      "value": "all",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 2
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "respective",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 3
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "accessed",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "downloaded",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "tab",
      "weight": 1
    },
    {
      "value": "towards",
      "weight": 1
    },
    {
      "value": "bottom",
      "weight": 1
    }
  ],
  myOrdersProvidePurchaseOrder: [
    {
      "value": "provide",
      "weight": 1
    },
    {
      "value": "purchase",
      "weight": 3
    },
    {
      "value": "order",
      "weight": 5
    },
    {
      "value": "placed",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "respective",
      "weight": 1
    },
    {
      "value": "using",
      "weight": 1
    },
    {
      "value": "attach",
      "weight": 1
    },
    {
      "value": "document",
      "weight": 3
    },
    {
      "value": "function",
      "weight": 1
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "attached",
      "weight": 1
    },
    {
      "value": "documents",
      "weight": 1
    },
    {
      "value": "tab",
      "weight": 1
    },
    {
      "value": "select",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "type",
      "weight": 1
    },
    {
      "value": "upload",
      "weight": 1
    }
  ],
  myOrdersHowManyOrdersOnMyAccount: [
    {
      "value": "many",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 6
    },
    {
      "value": "account",
      "weight": 2
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "check",
      "weight": 1
    },
    {
      "value": "number",
      "weight": 2
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "through",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "provide",
      "weight": 1
    },
    {
      "value": "breakdown",
      "weight": 1
    },
    {
      "value": "all",
      "weight": 2
    },
    {
      "value": "category",
      "weight": 2
    },
    {
      "value": "addition",
      "weight": 1
    },
    {
      "value": "overall",
      "weight": 1
    },
    {
      "value": "count",
      "weight": 1
    },
    {
      "value": "shown",
      "weight": 1
    },
    {
      "value": "displayed",
      "weight": 1
    },
    {
      "value": "against",
      "weight": 1
    }
  ],
  myOrdersStatus: [
    {
      "value": "status",
      "weight": 5
    },
    {
      "value": "order",
      "weight": 4
    },
    {
      "value": "your",
      "weight": 2
    },
    {
      "value": "displayed",
      "weight": 1
    },
    {
      "value": "against",
      "weight": 1
    },
    {
      "value": "property",
      "weight": 1
    },
    {
      "value": "each",
      "weight": 1
    },
    {
      "value": "product",
      "weight": 2
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "inherits",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 2
    },
    {
      "value": "utility",
      "weight": 2
    },
    {
      "value": "search",
      "weight": 2
    },
    {
      "value": "report",
      "weight": 1
    },
    {
      "value": "map",
      "weight": 1
    },
    {
      "value": "has",
      "weight": 1
    },
    {
      "value": "dependance",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "before",
      "weight": 1
    },
    {
      "value": "fulfilled",
      "weight": 1
    },
    {
      "value": "every",
      "weight": 1
    },
    {
      "value": "view",
      "weight": 1
    },
    {
      "value": "ordered",
      "weight": 1
    },
    {
      "value": "through",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "gained",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    }
  ],
  myOrdersRequestAnUpgrade: [
    {
      "value": "request",
      "weight": 2
    },
    {
      "value": "upgrade",
      "weight": 2
    },
    {
      "value": "order",
      "weight": 3
    },
    {
      "value": "placed",
      "weight": 1
    },
    {
      "value": "possible",
      "weight": 1
    },
    {
      "value": "such",
      "weight": 2
    },
    {
      "value": "adding",
      "weight": 1
    },
    {
      "value": "utility",
      "weight": 1
    },
    {
      "value": "search",
      "weight": 1
    },
    {
      "value": "map",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "type",
      "weight": 1
    },
    {
      "value": "permits",
      "weight": 1
    },
    {
      "value": "other",
      "weight": 1
    },
    {
      "value": "changes",
      "weight": 1
    },
    {
      "value": "revising",
      "weight": 1
    },
    {
      "value": "turnaround",
      "weight": 1
    },
    {
      "value": "time",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 2
    },
    {
      "value": "need",
      "weight": 1
    },
    {
      "value": "requested",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 2
    },
    {
      "value": "phone",
      "weight": 1
    },
    {
      "value": "number",
      "weight": 1
    },
    {
      "value": "enquiry",
      "weight": 1
    },
    {
      "value": "form",
      "weight": 1
    },
    {
      "value": "at",
      "weight": 1
    },
    {
      "value": "discretion",
      "weight": 1
    }
  ],
  myOrdersValid: [
    {
      "value": "long",
      "weight": 1
    },
    {
      "value": "utility",
      "weight": 2
    },
    {
      "value": "search",
      "weight": 3
    },
    {
      "value": "product",
      "weight": 1
    },
    {
      "value": "valid",
      "weight": 2
    },
    {
      "value": "accordance",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "industry",
      "weight": 1
    },
    {
      "value": "best",
      "weight": 1
    },
    {
      "value": "practice",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 2
    },
    {
      "value": "pas",
      "weight": 1
    },
    {
      "value": "128",
      "weight": 1
    },
    {
      "value": "compliant",
      "weight": 1
    },
    {
      "value": "type",
      "weight": 1
    },
    {
      "value": "d",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "through",
      "weight": 1
    },
    {
      "value": "report",
      "weight": 1
    },
    {
      "value": "map",
      "weight": 1
    },
    {
      "value": "products",
      "weight": 1
    },
    {
      "value": "only",
      "weight": 1
    },
    {
      "value": "90",
      "weight": 1
    },
    {
      "value": "days",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "date",
      "weight": 1
    },
    {
      "value": "issue",
      "weight": 1
    }
  ],
  myOrdersDue: [
    {
      "value": "see",
      "weight": 1
    },
    {
      "value": "when",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 3
    },
    {
      "value": "due",
      "weight": 2
    },
    {
      "value": "date",
      "weight": 1
    },
    {
      "value": "found",
      "weight": 1
    },
    {
      "value": "progress",
      "weight": 1
    },
    {
      "value": "view",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 2
    },
    {
      "value": "they",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "also",
      "weight": 1
    },
    {
      "value": "shown",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "dashboard",
      "weight": 1
    }
  ],
  myOrdersComplaint: [{
    "value": "am",
    "weight": 1
  },
  {
    "value": "unhappy",
    "weight": 1
  },
  {
    "value": "with",
    "weight": 1
  },
  {
    "value": "orderservice",
    "weight": 1
  },
  {
    "value": "raise",
    "weight": 1
  },
  {
    "value": "complaint",
    "weight": 1
  },
  {
    "value": "we",
    "weight": 1
  },
  {
    "value": "pride",
    "weight": 1
  },
  {
    "value": "ourselves",
    "weight": 1
  },
  {
    "value": "market",
    "weight": 1
  },
  {
    "value": "leading",
    "weight": 1
  },
  {
    "value": "customer",
    "weight": 1
  },
  {
    "value": "satisfication",
    "weight": 1
  },
  {
    "value": "however",
    "weight": 1
  },
  {
    "value": "you",
    "weight": 1
  },
  {
    "value": "issue",
    "weight": 1
  },
  {
    "value": "relating",
    "weight": 1
  },
  {
    "value": "order",
    "weight": 1
  },
  {
    "value": "contact",
    "weight": 1
  },
  {
    "value": "via",
    "weight": 1
  },
  {
    "value": "enquiry",
    "weight": 1
  },
  {
    "value": "form",
    "weight": 1
  }],
  myAccountUpdateDetails: [
    {
      "value": "update",
      "weight": 2
    },
    {
      "value": "account",
      "weight": 3
    },
    {
      "value": "details",
      "weight": 2
    },
    {
      "value": "you",
      "weight": 2
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 2
    },
    {
      "value": "these",
      "weight": 1
    },
    {
      "value": "only",
      "weight": 1
    },
    {
      "value": "updated",
      "weight": 1
    },
    {
      "value": "when",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "being",
      "weight": 1
    },
    {
      "value": "progressed",
      "weight": 1
    },
    {
      "value": "require",
      "weight": 1
    },
    {
      "value": "urgent",
      "weight": 1
    },
    {
      "value": "change",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "needs",
      "weight": 1
    },
    {
      "value": "made",
      "weight": 1
    },
    {
      "value": "contact",
      "weight": 1
    }
  ],
  myAccountAddUsersToMyAccount: [
    {
      "value": "add",
      "weight": 1
    },
    {
      "value": "other",
      "weight": 1
    },
    {
      "value": "people",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 4
    },
    {
      "value": "individuals",
      "weight": 1
    },
    {
      "value": "only",
      "weight": 1
    },
    {
      "value": "used",
      "weight": 1
    },
    {
      "value": "one",
      "weight": 1
    },
    {
      "value": "person",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "individual",
      "weight": 2
    },
    {
      "value": "accounts",
      "weight": 2
    },
    {
      "value": "managed",
      "weight": 1
    },
    {
      "value": "under",
      "weight": 2
    },
    {
      "value": "company",
      "weight": 2
    },
    {
      "value": "multiple",
      "weight": 1
    },
    {
      "value": "registered",
      "weight": 1
    },
    {
      "value": "yourself",
      "weight": 1
    },
    {
      "value": "colleagues",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "linked",
      "weight": 1
    },
    {
      "value": "single",
      "weight": 1
    }
  ],
  myAccountForgottenDetails: [
    {
      "value": "forgotten",
      "weight": 2
    },
    {
      "value": "login",
      "weight": 1
    },
    {
      "value": "details",
      "weight": 2
    },
    {
      "value": "your",
      "weight": 4
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "registered",
      "weight": 2
    },
    {
      "value": "against",
      "weight": 1
    },
    {
      "value": "email",
      "weight": 2
    },
    {
      "value": "address",
      "weight": 2
    },
    {
      "value": "youve",
      "weight": 1
    },
    {
      "value": "password",
      "weight": 1
    },
    {
      "value": "reset",
      "weight": 1
    },
    {
      "value": "website",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "need",
      "weight": 1
    },
    {
      "value": "reminded",
      "weight": 1
    },
    {
      "value": "contact",
      "weight": 1
    },
    {
      "value": "verify",
      "weight": 1
    },
    {
      "value": "these",
      "weight": 1
    }
  ],
  myAccountContactAccountManager: [
    {
      "value": "contact",
      "weight": 2
    },
    {
      "value": "account",
      "weight": 5
    },
    {
      "value": "manager",
      "weight": 3
    },
    {
      "value": "has",
      "weight": 1
    },
    {
      "value": "been",
      "weight": 1
    },
    {
      "value": "assigned",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 1
    },
    {
      "value": "details",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "tab",
      "weight": 1
    }
  ],
  myAccountChangeOrderPreferences: [
    {
      "value": "change",
      "weight": 2
    },
    {
      "value": "ordering",
      "weight": 1
    },
    {
      "value": "preferences",
      "weight": 3
    },
    {
      "value": "your",
      "weight": 2
    },
    {
      "value": "order",
      "weight": 3
    },
    {
      "value": "defined",
      "weight": 1
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "area",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "tab",
      "weight": 1
    },
    {
      "value": "these",
      "weight": 1
    },
    {
      "value": "updated",
      "weight": 1
    },
    {
      "value": "when",
      "weight": 1
    },
    {
      "value": "being",
      "weight": 1
    },
    {
      "value": "progressed",
      "weight": 1
    },
    {
      "value": "however",
      "weight": 1
    },
    {
      "value": "you",
      "weight": 1
    },
    {
      "value": "require",
      "weight": 1
    },
    {
      "value": "urgent",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "needs",
      "weight": 1
    },
    {
      "value": "made",
      "weight": 1
    },
    {
      "value": "contact",
      "weight": 1
    }
  ],
  myAccountRetrieveInvoices: [
    {
      "value": "retrieve",
      "weight": 1
    },
    {
      "value": "invoices",
      "weight": 2
    },
    {
      "value": "orders",
      "weight": 2
    },
    {
      "value": "from",
      "weight": 2
    },
    {
      "value": "account",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 2
    },
    {
      "value": "fulfillment",
      "weight": 1
    },
    {
      "value": "platform",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 2
    },
    {
      "value": "generate",
      "weight": 1
    },
    {
      "value": "all",
      "weight": 1
    },
    {
      "value": "not",
      "weight": 1
    },
    {
      "value": "purchased",
      "weight": 1
    },
    {
      "value": "through",
      "weight": 1
    },
    {
      "value": "paypal",
      "weight": 3
    },
    {
      "value": "any",
      "weight": 1
    },
    {
      "value": "submitted",
      "weight": 1
    },
    {
      "value": "paid",
      "weight": 1
    },
    {
      "value": "using",
      "weight": 1
    },
    {
      "value": "recieve",
      "weight": 1
    },
    {
      "value": "receipt",
      "weight": 1
    },
    {
      "value": "emailed",
      "weight": 1
    },
    {
      "value": "them",
      "weight": 1
    },
    {
      "value": "directly",
      "weight": 1
    }
  ],
  deliveryRetreiveDeliverables: [
    {
      "value": "retrieve",
      "weight": 1
    },
    {
      "value": "deliverables",
      "weight": 4
    },
    {
      "value": "order",
      "weight": 3
    },
    {
      "value": "all",
      "weight": 1
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "your",
      "weight": 2
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "accessed",
      "weight": 1
    },
    {
      "value": "via",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "list",
      "weight": 1
    },
    {
      "value": "found",
      "weight": 1
    },
    {
      "value": "listed",
      "weight": 1
    },
    {
      "value": "within",
      "weight": 1
    },
    {
      "value": "tab",
      "weight": 1
    }
  ],
  deliveryRetrievePreviousDeliverables: [
    {
      "value": "retrieve",
      "weight": 1
    },
    {
      "value": "deliverables",
      "weight": 3
    },
    {
      "value": "previous",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "that",
      "weight": 1
    },
    {
      "value": "may",
      "weight": 1
    },
    {
      "value": "lost",
      "weight": 1
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "who",
      "weight": 1
    },
    {
      "value": "exceeded",
      "weight": 1
    },
    {
      "value": "90",
      "weight": 1
    },
    {
      "value": "day",
      "weight": 1
    },
    {
      "value": "validity",
      "weight": 1
    },
    {
      "value": "period",
      "weight": 1
    },
    {
      "value": "advocated",
      "weight": 1
    },
    {
      "value": "pas",
      "weight": 1
    },
    {
      "value": "128",
      "weight": 1
    },
    {
      "value": "removed",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "file",
      "weight": 1
    },
    {
      "value": "transfer",
      "weight": 1
    },
    {
      "value": "system",
      "weight": 1
    },
    {
      "value": "exceptional",
      "weight": 1
    },
    {
      "value": "cases",
      "weight": 1
    },
    {
      "value": "these",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "request",
      "weight": 1
    }
  ],
  deliveryReceivePhysicalFormat: [
    {
      "value": "receive",
      "weight": 1
    },
    {
      "value": "deliverables",
      "weight": 2
    },
    {
      "value": "physical",
      "weight": 1
    },
    {
      "value": "format",
      "weight": 2
    },
    {
      "value": "such",
      "weight": 1
    },
    {
      "value": "paper",
      "weight": 2
    },
    {
      "value": "cd",
      "weight": 2
    },
    {
      "value": "whilst",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 2
    },
    {
      "value": "preference",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "digital",
      "weight": 1
    },
    {
      "value": "printout",
      "weight": 1
    },
    {
      "value": "requested",
      "weight": 1
    },
    {
      "value": "utility",
      "weight": 1
    },
    {
      "value": "search",
      "weight": 1
    },
    {
      "value": "report",
      "weight": 1
    },
    {
      "value": "part",
      "weight": 1
    },
    {
      "value": "ordering",
      "weight": 1
    },
    {
      "value": "process",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 1
    },
    {
      "value": "fixed",
      "weight": 1
    },
    {
      "value": "price",
      "weight": 1
    },
    {
      "value": "charge",
      "weight": 1
    },
    {
      "value": "both",
      "weight": 1
    },
    {
      "value": "formats",
      "weight": 1
    },
    {
      "value": "which",
      "weight": 1
    },
    {
      "value": "stated",
      "weight": 1
    },
    {
      "value": "pricing",
      "weight": 1
    },
    {
      "value": "page",
      "weight": 1
    }
  ],
  deliveryUsmDataFormat: [
    {
      "value": "data",
      "weight": 1
    },
    {
      "value": "format",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 2
    },
    {
      "value": "utility",
      "weight": 2
    },
    {
      "value": "search",
      "weight": 2
    },
    {
      "value": "map",
      "weight": 2
    },
    {
      "value": "currently",
      "weight": 1
    },
    {
      "value": "autocad",
      "weight": 2
    },
    {
      "value": "dwg",
      "weight": 1
    },
    {
      "value": "dxf",
      "weight": 1
    },
    {
      "value": "adobe",
      "weight": 1
    },
    {
      "value": "pdf",
      "weight": 1
    },
    {
      "value": "some",
      "weight": 1
    },
    {
      "value": "instances",
      "weight": 1
    },
    {
      "value": "we",
      "weight": 1
    },
    {
      "value": "also",
      "weight": 1
    },
    {
      "value": "support",
      "weight": 1
    },
    {
      "value": "other",
      "weight": 1
    },
    {
      "value": "cad",
      "weight": 1
    },
    {
      "value": "gis",
      "weight": 1
    },
    {
      "value": "formats",
      "weight": 1
    },
    {
      "value": "although",
      "weight": 1
    },
    {
      "value": "this",
      "weight": 1
    },
    {
      "value": "at",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "discretion",
      "weight": 1
    }
  ],
  deliveryDeliverableNotAvailable: [
    {
      "value": "tried",
      "weight": 1
    },
    {
      "value": "retrieve",
      "weight": 1
    },
    {
      "value": "deliverables",
      "weight": 3
    },
    {
      "value": "previous",
      "weight": 1
    },
    {
      "value": "order",
      "weight": 1
    },
    {
      "value": "but",
      "weight": 1
    },
    {
      "value": "they",
      "weight": 2
    },
    {
      "value": "werent",
      "weight": 1
    },
    {
      "value": "available",
      "weight": 1
    },
    {
      "value": "associated",
      "weight": 1
    },
    {
      "value": "with",
      "weight": 1
    },
    {
      "value": "orders",
      "weight": 1
    },
    {
      "value": "who",
      "weight": 1
    },
    {
      "value": "expired",
      "weight": 1
    },
    {
      "value": "ie",
      "weight": 1
    },
    {
      "value": "beyond",
      "weight": 1
    },
    {
      "value": "90",
      "weight": 1
    },
    {
      "value": "day",
      "weight": 1
    },
    {
      "value": "validity",
      "weight": 1
    },
    {
      "value": "period",
      "weight": 1
    },
    {
      "value": "removed",
      "weight": 1
    },
    {
      "value": "from",
      "weight": 1
    },
    {
      "value": "our",
      "weight": 1
    },
    {
      "value": "file",
      "weight": 1
    },
    {
      "value": "transfer",
      "weight": 1
    },
    {
      "value": "system",
      "weight": 1
    },
    {
      "value": "exceptional",
      "weight": 1
    },
    {
      "value": "cases",
      "weight": 1
    },
    {
      "value": "these",
      "weight": 1
    },
    {
      "value": "provided",
      "weight": 1
    },
    {
      "value": "request",
      "weight": 1
    },
    {
      "value": "will",
      "weight": 1
    },
    {
      "value": "archived",
      "weight": 1
    }
  ],
}

const answerBody = {
  registerToPlaceOrder: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, it is necessary for an account to be created. This enables us to provide you with the best possible service in managing your account and you leverage on the benefits of an account manager and other benefits we might be able to offer."
    }
  ],
  registerForOnAccount: [
    {
      "href": null,
      "partType": "text",
      "text": "To register an account you only need to provide a valid email address, name, phone number and address. A password will also be required when finalising your account creation."
    }
  ],
  registerOnBehalfOfSomeoneElse: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, however you must have their permission and the account must be registered against their email address. This is imperative as it will be used to finalise your account creation in addition to being sent email notifications throughout the lifetime of the account."
    }
  ],
  registerMoreThanOneUser: [
    {
      "href": null,
      "partType": "text",
      "text": "No, an individual’s account cannot be shared by multiple users. However, individual accounts are managed under a company record. It is therefore possible to register multiple individual accounts for yourself and colleagues which will be associated to the same company."
    }
  ],
  registerHowLongToEnableInvoicing: [
    {
      "href": null,
      "partType": "text",
      "text": "Your account will be active once you create a password as part of the registration process. However, if you would like to be invoiced for orders, it can take up to 3 working days to be activated. In the interim, you will still be able to place orders paying via PayPal."
    }
  ],
  registerContactDetails: [
    {
      "href": null,
      "partType": "text",
      "text": "If you encounter an issue when trying to register an account, please either call us on "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": " or use the enquiry form on this page and a member of our team will get back to you."
    }
  ],
  orderingPlaceOrderOnWebsite: [
    {
      "href": null,
      "partType": "text",
      "text": "Ordering via the website is our preferred method, however we can accommodate placing an order by email. Although, all orders will be created against your online account and your deliverables will be provided through your online account."
    }
  ],
  orderingWhatInformationDoIProvide: [
    {
      "href": null,
      "partType": "text",
      "text": "To order our Utility Search Report you simply need to draw a site boundary, provide a site reference, select a description of works and request a turnaround time. Optionally, you can also provide a ‘on-behalf of’ proof letter and request the inclusion of a Utility Search Map."
    }
  ],
  orderingPayForOrder: [
    {
      "href": null,
      "partType": "text",
      "text": "We support a number of payment methods, most users will prefer to be invoiced on a monthly basis. However, we also support payment via credit card, debit card or a PayPal account."
    }
  ],
  orderingCanIOrderMultipleSites: [
    {
      "href": null,
      "partType": "text",
      "text": "Unfortunately not at this time, however we are happy to discuss facilitating these large bulk orders. Please contact us on "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": " for one of our account managers to help."
    }
  ],
  orderingContactTheTeam: [
    {
      "href": null,
      "partType": "text",
      "text": "You can contact us either via the enquiry forms available on this page or through our phone number "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": "."
    }
  ],
  orderingEstimate: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, our dynamic pricing engine will generate an estimate for any orders up to 1 unit in size (i.e. 1km2), however we are unable to provide estimates for our Utility Search Map for PayPal accounts. For accounts enabled with monthly invoicing we provide estimates for our Utility Search Report up to 32 units in size, and our Utility Search Map up to 1 unit in size. You can request to enable monthly invoicing on your account at any time when ordering at the checkout stage or via the 'My Account' page."
    }
  ],
  orderingProvideSiteBoundary: [
    {
      "href": null,
      "partType": "text",
      "text": "Draw the site boundary using the polygon or line tools available on the Draw Site stage of the ordering process. Please note only a single polygon site boundary is permitted. The line tool is provided to allow you to easily trace linear assets, such as those which might follow a road or railway route."
    }
  ],
  orderingSubmitLargeNumber: [
    {
      "href": null,
      "partType": "text",
      "text": "At present, we would advise you to contact us on "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": " or via the enquiry form so we can bulk upload your orders into our order fulfilment system."
    }
  ],
  orderingSiteSizeLimit: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, although this depends on your account status. A PayPal account can only order if the site size is less than 1 unit (i.e. 1km2) and is currently limited to the Utility Search Report. A account enabled with monthly invoicing can order a Utility Search Report up to 32 units in size, and a Utility Search Map up to 1 unit in size."
    }
  ],
  orderingReceivingMyOrder: [
    {
      "href": null,
      "partType": "text",
      "text": "Your order can be found on the 'My Orders' page when you are signed into your account. Any deliverable associated with an order can be accessed and downloaded from the deliverables table on the respective 'My Order' page. You will also recieve an email notification when your order is available for download along with any revisions provided."
    }
  ],
  myOrdersAmendOrder: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, however it is subject to the order's status and the type of amendment requested. The website will allow you to add a Utility Search Map to an active (none expired) order dependent on your account payment type. However, other amendments must be performed by our operations team and requested via our enquiry form or by speaking to an account manager on "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": "."
    }
  ],
  myOrdersCancelling: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, however it might be subject to a charge calculated based on the percentage of the work undertaken by our operations team and any disbursements incurred from 3rd party costs."
    }
  ],
  myOrdersDeliverables: [
    {
      "href": null,
      "partType": "text",
      "text": "All deliverables associated with your order are available on the respective 'My Order' page which can be accessed via your 'My Orders' page. Deliverables can be downloaded from the Deliverables tab towards the bottom of the page."
    }
  ],
  myOrdersProvidePurchaseOrder: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, this can be provided for the respective order using the attach document function available via the Attached Documents tab. Select Purchase Order from the document type and upload a purchase order document."
    }
  ],
  myOrdersHowManyOrdersOnMyAccount: [
    {
      "href": null,
      "partType": "text",
      "text": "You can check the number of orders associated with your account through the 'My Orders' page. This will provide a breakdown of all orders by category, in addition to an overall count of orders shown by the number displayed against the All Orders category."
    }
  ],
  myOrdersStatus: [
    {
      "href": null,
      "partType": "text",
      "text": "The status of your order is displayed against the Status property for each product associated with an order. The order inherits the status from the Utility Search Report as the Utility Search Map has a dependance on this product before it can be fulfilled. The status for every view ordered through your account can be gained from the 'My Orders' page."
    }
  ],
  myOrdersRequestAnUpgrade: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, it is possible to request an upgrade to an order. Such as adding a Utility Search Map to an order if you account type permits. Other changes such as revising the turnaround time will need to be requested via our phone number "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": " or enquiry form and will be at our discretion."
    }
  ],
  myOrdersValid: [
    {
      "href": null,
      "partType": "text",
      "text": "In accordance with industry best practice, our PAS 128 compliant Type D search as provided through our Utility Search Report and Map products are only valid for 90 days from the date of issue."
    }
  ],
  myOrdersDue: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, the due date for orders can be found on the In Progress view of the 'My Orders' page."
    }
  ],
  myOrdersComplaint: [
    {
      "href": null,
      "partType": "text",
      "text": "We pride ourselves on market leading customer satisfication, however if you have an issue relating to an order please contact us on "
    },
    {
      "href": null,
      "partType": "infinityCallTrackingNumber",
      "text": null
    },
    {
      "href": null,
      "partType": "text",
      "text": " or via the enquiry form."
    }
  ],
  myAccountUpdateDetails: [
    {
      "href": null,
      "partType": "text",
      "text": "You can update your account details via the 'My Account' page, however these can only be updated when no order is being progressed. However, if you require an urgent change which needs to be made please contact us."
    }
  ],
  myAccountAddUsersToMyAccount: [
    {
      "href": null,
      "partType": "text",
      "text": "No, an individual’s account can only be used by one person. However, individual accounts are managed under a company account. So, multiple individual accounts can be registered for yourself and colleagues which will be linked under a single company account."
    }
  ],
  myAccountForgottenDetails: [
    {
      "href": null,
      "partType": "text",
      "text": "Your account is registered against your email address, so if you've forgotten your password it can be reset on the website. However, if you need to be reminded of your registered email address please contact us to verify these details."
    }
  ],
  myAccountContactAccountManager: [
    {
      "href": null,
      "partType": "text",
      "text": "If an account manager has been assigned to your account, the contact details will be available on the 'My Account' page via the 'Account Manager' tab."
    }
  ],
  myAccountChangeOrderPreferences: [
    {
      "href": null,
      "partType": "text",
      "text": "Your order preferences are defined in your 'My Account' area via the 'Order Preferences' tab. These can be updated when no order is being progressed. However, if you require an urgent change which needs to be made please contact us."
    }
  ],
  myAccountRetrieveInvoices: [
    {
      "href": null,
      "partType": "text",
      "text": "Our order fulfillment platform will generate invoices for all orders not purchased through PayPal. Any order submitted and paid using PayPal will recieve a receipt emailed to them directly from PayPal."
    }
  ],
  deliveryRetreiveDeliverables: [
    {
      "href": null,
      "partType": "text",
      "text": "All deliverables associated with your order are available on the 'My Order' page which can be accessed via your 'My Orders' list. The deliverables can be found listed within the 'Deliverables' tab."
    }
  ],
  deliveryRetrievePreviousDeliverables: [
    {
      "href": null,
      "partType": "text",
      "text": "Deliverables associated with orders who have exceeded the 90 day validity period (as advocated by PAS 128) are removed from our file transfer system. In exceptional cases, these deliverables can be provided on request."
    }
  ],
  deliveryReceivePhysicalFormat: [
    {
      "href": null,
      "partType": "text",
      "text": "Yes, whilst our preference is for deliverables to be provided in a digital format. A CD or paper printout can be requested for our Utility Search Report as part of the ordering process. We have a fixed price charge for both formats which are stated on the Pricing page."
    }
  ],
  deliveryUsmDataFormat: [
    {
      "href": null,
      "partType": "text",
      "text": "The Utility Search Map can currently be provided in AutoCAD DWG, AutoCAD DXF and Adobe PDF. In some instances we can also support other CAD and GIS formats, although this is at our discretion."
    }
  ],
  deliveryDeliverableNotAvailable: [
    {
      "href": null,
      "partType": "text",
      "text": "Deliverables associated with orders who have expired (i.e. beyond the 90 day validity period) are removed from our file transfer system. In exceptional cases, these deliverables can be provided on request as they will be archived."
    }
  ],
}

export default class FrequentlyAskedQuestionData {

  readonly questions: ReadonlyArray<FrequentlyAskedQuestion> = [
    new FrequentlyAskedQuestion(
      answerBody.registerToPlaceOrder,
      ["Registration"],
      keyWords.registerToPlaceOrder,
      "Do I need to register for an account to place an order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.registerForOnAccount,
      ["Registration"],
      keyWords.registerForOnAccount,
      "What do I need to provide to register for an account?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.registerOnBehalfOfSomeoneElse,
      ["Registration"],
      keyWords.registerOnBehalfOfSomeoneElse,
      "Can I register on someone else’s behalf?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.registerMoreThanOneUser,
      ["Registration"],
      keyWords.registerMoreThanOneUser,
      "Can I register more than one person under an account?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.registerHowLongToEnableInvoicing,
      ["Registration"],
      keyWords.registerHowLongToEnableInvoicing,
      "How long does it take to enable monthly invoicing on my account?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.registerContactDetails,
      ["Registration"],
      keyWords.registerContactDetails,
      "Who do I contact if my registration details aren’t accepted?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingPlaceOrderOnWebsite,
      ["Ordering"],
      keyWords.orderingPlaceOrderOnWebsite,
      "Do I have to place my order on the website?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingWhatInformationDoIProvide,
      ["Ordering"],
      keyWords.orderingWhatInformationDoIProvide,
      "What information do I need to provide to order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingPayForOrder,
      ["Ordering"],
      keyWords.orderingPayForOrder,
      "How do I pay for my order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingCanIOrderMultipleSites,
      ["Ordering"],
      keyWords.orderingCanIOrderMultipleSites,
      "Can I order multiple sites in a single order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingContactTheTeam,
      ["Ordering"],
      keyWords.orderingContactTheTeam,
      "How do I contact someone to discuss a matter relating to an order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingEstimate,
      ["Ordering"],
      keyWords.orderingEstimate,
      "Can I get an estimate of the cost before I submit an order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingProvideSiteBoundary,
      ["Ordering"],
      keyWords.orderingProvideSiteBoundary,
      "How can I provide the site boundary I want searched?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingSubmitLargeNumber,
      ["Ordering"],
      keyWords.orderingSubmitLargeNumber,
      "How can I submit a large number of orders?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingSiteSizeLimit,
      ["Ordering"],
      keyWords.orderingSiteSizeLimit,
      "Is there a limit on the size of site I can request for an order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.orderingReceivingMyOrder,
      ["Ordering"],
      keyWords.orderingReceivingMyOrder,
      "How do I receive my order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersAmendOrder,
      ["My Orders"],
      keyWords.myOrdersAmendOrder,
      "Can I amend my order once it has been placed?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersCancelling,
      ["My Orders"],
      keyWords.myOrdersCancelling,
      "Can I cancel my order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersDeliverables,
      ["My Orders"],
      keyWords.myOrdersDeliverables,
      "How do I retrieve the deliverables associated with my order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersProvidePurchaseOrder,
      ["My Orders"],
      keyWords.myOrdersProvidePurchaseOrder,
      "Can I provide a purchase order for an order I have placed?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersHowManyOrdersOnMyAccount,
      ["My Orders"],
      keyWords.myOrdersHowManyOrdersOnMyAccount,
      "How many orders do I have on my account?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersStatus,
      ["My Orders"],
      keyWords.myOrdersStatus,
      "What is the status of my order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersRequestAnUpgrade,
      ["My Orders"],
      keyWords.myOrdersRequestAnUpgrade,
      "Can I request an upgrade to an order I placed?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersValid,
      ["My Orders"],
      keyWords.myOrdersValid,
      "How long is my Utility Search Product valid for?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersDue,
      ["My Orders"],
      keyWords.myOrdersDue,
      "Can I see when my order(s) are due?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myOrdersComplaint,
      ["My Orders"],
      keyWords.myOrdersComplaint,
      "I am unhappy with my order\/service, how can I raise a complaint?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myAccountUpdateDetails,
      ["My Account"],
      keyWords.myAccountUpdateDetails,
      "How can I update my account details?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myAccountAddUsersToMyAccount,
      ["My Account"],
      keyWords.myAccountAddUsersToMyAccount,
      "Can I add other people to my account?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myAccountForgottenDetails,
      ["My Account"],
      keyWords.myAccountForgottenDetails,
      "I have forgotten my login details, what do I do?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myAccountContactAccountManager,
      ["My Account"],
      keyWords.myAccountContactAccountManager,
      "How do I contact my account manager?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myAccountChangeOrderPreferences,
      ["My Account"],
      keyWords.myAccountChangeOrderPreferences,
      "How do I change my ordering preferences?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.myAccountRetrieveInvoices,
      ["My Account"],
      keyWords.myAccountRetrieveInvoices,
      "Can I retrieve invoices for my order(s) from my account?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.deliveryRetreiveDeliverables,
      ["Delivery"],
      keyWords.deliveryRetreiveDeliverables,
      "How can I retrieve the deliverables for my order?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.deliveryRetrievePreviousDeliverables,
      ["Delivery"],
      keyWords.deliveryRetrievePreviousDeliverables,
      "How can I retrieve deliverables for a previous order that I may have lost?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.deliveryReceivePhysicalFormat,
      ["Delivery"],
      keyWords.deliveryReceivePhysicalFormat,
      "Can I receive deliverables in a physical format such as paper or CD?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.deliveryUsmDataFormat,
      ["Delivery"],
      keyWords.deliveryUsmDataFormat,
      "What data format can be provided for the Utility Search Map?"
    ),
    new FrequentlyAskedQuestion(
      answerBody.deliveryDeliverableNotAvailable,
      ["Delivery"],
      keyWords.deliveryDeliverableNotAvailable,
      "I tried to retrieve deliverables for a previous order but they weren’t available?"
    ),
  ];

  readonly allCategories: ReadonlyArray<string> = [
    "Delivery", "My Account", "My Orders", "Ordering", "Registration"
  ];
}